// extracted by mini-css-extract-plugin
export default {"mergeabilityIcon":"MergeabilityIcon-module__mergeabilityIcon--GOu7M"};